<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: lc
 * @LastEditTime: 2023-07-03 15:31:07
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-input v-model="queryParam.key"
                  size="mini"
                  clearable
                  placeholder="请输入关键词查找" />
      </div>
      <div class="shaixuan-item">
        <el-button type="primary"
                   size="mini"
                   @click="searchClick()"
                   icon="el-icon-search">
          查询
        </el-button>
        <el-button @click="clickItem(0)"
                   type="primary"
                   size="mini"
                   icon="el-icon-plus">
          新增
        </el-button>
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading"
                :data="tableData"
                style="width: 100%">
        <el-table-column prop="id"
                         label="id"
                         width="180" />
        <el-table-column prop="name"
                         label="名称"
                         width="200" />
        <el-table-column prop="admin"
                         label="类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.is_mobile == true"
                    type="success">手机</el-tag>
            <el-tag v-else
                    type="success">pc</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="content"
                         label="内容"
                         width="180">
          <template slot-scope="scope">
            <el-tooltip :content="scope.row.content"
                        popper-class="tooltip-width"
                        effect="dark"
                        placement="top">
              <span class=""
                    v-if="
                    scope.row.content && scope.row.content.length > 30
                  ">{{ scope.row.content.slice(0, 30) + "..." }}</span>
              <span v-else>{{ scope.row.content }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         align="center"
                         label="操作"
                         width="180">
          <template slot-scope="scope">
            <div class="btns-wrap">
              <el-button type="danger"
                         @click="remove(scope.row)"
                         size="mini">删除</el-button>
              <el-button type="danger"
                         style="
                                    background: #1067e0;
                                    border-color: #1067e0;
                                "
                         size="mini"
                         @click="clickItem(1, scope.row)">修改</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total"
                  :total="total"
                  :page.sync="queryParam.page"
                  :limit.sync="queryParam.size"
                  @pagination="getList" />
    </div>
    <el-drawer custom-class="custom-drawer"
               :visible.sync="showDrawer"
               :close-on-press-escape="false"
               :wrapper-closable="false"
               :show-close="false"
               size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i class="el-icon-circle-close close-btn pointer"
             @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <PositionAdd ref="PositionAdd"
                     @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import ad from "@/api/console/ad";
import PositionAdd from "./PositionAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      queryParam: {
        key: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
    };
  },
  components: {
    Pagination,
    PositionAdd,
  },
  created () {
  },
  mounted () {
    this.getList();
  },
  methods: {
    onUpdateDrawer (status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun () {
      this.showDrawer = false;
      this.$refs.PositionAdd.resetForm();
    },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem (type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.PositionAdd.initFun(obj);
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick () {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList () {
      let that = this;
      this.listLoading = true;
      ad.list(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.count;
      });
    },
    remove (row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          ad.remove({ adpos_id: [row.id] }).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style>
.tooltip-width {
  max-width: 500px;
}
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
